import { useEffect, useState } from "react";

/** A copyable command or prompt. Copy uses the clipboard only; nothing is persisted. */
export function Command(props: { label: string; value: string; note?: string; kind?: "shell" | "prompt" }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 1_800);
    return () => clearTimeout(timer);
  }, [copied]);
  return <div className={`generated-command kind-${props.kind ?? "shell"}`}>
    <span className="generated-command-label">{props.label}</span>
    {props.kind === "prompt"
      ? <textarea readOnly value={props.value} rows={5} aria-label={props.label} />
      : <pre>{props.value}</pre>}
    <button type="button" onClick={() => {
      void navigator.clipboard.writeText(props.value).then(() => setCopied(true));
    }}>{copied ? "Copied" : "Copy"}</button>
    {props.note && <small className="muted generated-command-note">{props.note}</small>}
    <span className="visually-hidden" aria-live="polite">{copied ? `${props.label} copied` : ""}</span>
  </div>;
}

/** A single opaque value (an agent UUID, an invite URL) with a copy button. */
export function CopyField(props: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 1_800);
    return () => clearTimeout(timer);
  }, [copied]);
  return <div className="copy-field">
    <span className="copy-field-label">{props.label}</span>
    <code>{props.value}</code>
    <button type="button" onClick={() => {
      void navigator.clipboard.writeText(props.value).then(() => setCopied(true));
    }}>{copied ? "Copied" : "Copy"}</button>
  </div>;
}
